import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'

import { specializationEligibilityCriteriaApi } from 'onboarding/api/specializationEligibilityCriteriaApi'
import {
  TCreateCriteriaPayload,
  TUpdateCriteriaPayload,
} from 'onboarding/components/widgets/public/admin/eligibilityCriteria/models'

class SpecializationEligibilityCriteriaService {
  public existsActive(specializationCode: string, requestType: RequestTypes) {
    return specializationEligibilityCriteriaApi.existsActive(specializationCode, requestType)
  }

  public fetchByIdExtended(id: number) {
    return specializationEligibilityCriteriaApi.fetchByIdExtended(id)
  }

  public fetchActiveByCodeAndTypeExtended(specializationCode: string, requestType: RequestTypes) {
    return specializationEligibilityCriteriaApi.fetchActiveByCodeAndTypeExtended(
      specializationCode,
      requestType
    )
  }

  public fetchRevenueCriteriaThresholds(specializationCode: string, countryISO: string) {
    return specializationEligibilityCriteriaApi.fetchRevenueCriteriaThresholds(
      specializationCode,
      countryISO
    )
  }

  public composeListCrud() {
    return specializationEligibilityCriteriaApi.composeListCrud()
  }

  public composeListSpecializationWithoutCriteriaCrud(requestType: RequestTypes) {
    return specializationEligibilityCriteriaApi.composeListSpecializationWithoutCriteriaCrud(
      requestType
    )
  }

  public create(payload: TCreateCriteriaPayload) {
    return specializationEligibilityCriteriaApi.create(payload)
  }

  public update(id: number, payload: TUpdateCriteriaPayload) {
    return specializationEligibilityCriteriaApi.update(id, payload)
  }

  public delete(id: number) {
    return specializationEligibilityCriteriaApi.delete(id)
  }
}

export const specializationEligibilityCriteriaService =
  new SpecializationEligibilityCriteriaService()
